/* eslint react/prop-types: 0 */
import React from 'react';
import { sortByDate } from '../../../utils/date';
import { yardsToFurlongs } from '../../../utils/distance';
import { goingCodeSortFn } from '../../../utils/going';

import Abbr from '../../../shared/Abbr';
import ConditionsCell from './ConditionsCell';
import FinishingCell from './FinishingCell';
import CustomHeaderCell from './CustomHeaderCell';
import {
    raceDatetimeCell,
    oddsValueCell,
    jockeyShortNameCell,
    officialRatingRanOffCell,
    rpTopspeedCell,
    rpPostmarkCell,
    weightCarriedLbsCell,
} from './columnsCells';
import { numericAndDashSort } from '../../../utils/number';

const sortConfig = {
    course: { key: 'courseName', sortFn: 'alphabetic' },
    class: { key: 'raceClass', sortFn: 'numericReverse' },
    prize: { key: 'prizeSterling', sortFn: 'numeric' },
};

const columns = (onUpdate, sortKey) => [
    {
        key: 'raceDatetime',
        header: 'date',
        cell: raceDatetimeCell,
        sortFn: sortByDate('raceDatetime'),
    },
    {
        key: sortConfig[sortKey] ? sortConfig[sortKey].key : sortKey,
        header: () =>
            (<CustomHeaderCell
                onUpdate={onUpdate}
                sortBy={sortKey}
            />),
        cell: ConditionsCell,
        sortFn: sortConfig[sortKey] ? sortConfig[sortKey].sortFn : () => null,
    },
    {
        key: 'distanceFurlong',
        header: 'dist.',
        cell: ({ distanceYard }) => yardsToFurlongs(distanceYard),
        sortFn: 'numericReverse',
    },
    {
        key: 'goingTypeServicesDesc',
        header: 'gng.',
        sortFn: goingCodeSortFn,
    },
    {
        key: 'weightCarriedLbs',
        header: 'wgt / hdgr',
        cell: weightCarriedLbsCell,
    },
    {
        key: 'raceOutcomeCode',
        header: () => (
            <Abbr
                title="Pos. Finish dist / winner or Runner-up / Wgt"
                breakpoint="fromMedium"
            >
                    Pos.
            </Abbr>
        ),
        cell: FinishingCell,
        sortFn: 'numericReverse',
    },
    {
        key: 'oddsValue',
        header: 'sp',
        cell: oddsValueCell,
        sortFn: 'numericReverse',
    },
    {
        key: 'jockeyShortName',
        header: 'jockey',
        cell: jockeyShortNameCell,
        sortFn: 'byLastName',
    },
    {
        key: 'officialRatingRanOff',
        header: 'or',
        cell: officialRatingRanOffCell,
        sortFn: numericAndDashSort('officialRatingRanOff'),
    },
    {
        key: 'rpTopspeed',
        header: 'ts',
        cell: rpTopspeedCell,
        sortFn: numericAndDashSort('rpTopspeed'),
    },
    {
        key: 'rpPostmark',
        header: 'rpr',
        cell: rpPostmarkCell,
        sortFn: numericAndDashSort('rpPostmark'),
    },
    {
        key: 'myRating',
        header: 'mr',
    },
];

export default columns;



// WEBPACK FOOTER //
// ./src/js/horse/form/formTable/columns.jsx